export const locale = {
  lang: "it",
  data: {
    MENU: {
      EXTERNAL_USERS_LIST: "Fornitori",
      USERS_MANAGE: "Gestione utenti",
      CREATE_PROVIDER: "Crea fornitore",
      EDIT_PROVIDER: "Modifica fornitore",
      PROVIDER_DETAIL: "Dettaglio fornitore",
    },
    ALERT: {
      SUCCESS_CREATE_PROVIDER: "Fornitore creato con successo.",
      ERROR_CREATE_PROVIDER: "Errore nella creazione del fornitore.",
      SUCCESS_EDIT_PROVIDER: "Fornitore modificato con successo.",
      ERROR_EDIT_PROVIDER: "Errore nella modifica del fornitore.",
      SUCCESS_DELETE_PROVIDER: "Fornitore eliminato con successo.",
      ERROR_DELETE_PROVIDER: "Errore nell'eliminazione del fornitore.",
      PROVIDER_NOT_FOUND: "Fornitore non trovato.",
      SUCCESS_ADD_ADDRESS: "Indirizzo aggiunto con successo.",
      ERROR_ADD_ADDRESS: "Errore nell'aggiunta dell'indirizzo.",
      SUCCESS_DELETE_ADDRESS: "Indirizzo eliminato con successo.",
      ERROR_DELETE_ADDRESS: "Errore nell'eliminazione dell'indirizzo.",
      CONFIRM_DELETE_ADDRESS: "Sei sicuro di voler eliminare l'indirizzo?",
      SUCCESS_EDIT_ADDRESS: "Indirizzo modificato con successo.",
      ERROR_EDIT_ADDRESS: "Errore nella modifica dell'indirizzo.",
      ERROR_IN_FORM_REFERENT: "Errore nel form del referente.",
      SUCCESS_EDIT_REFERENT: "Referente modificato con successo.",
      ERROR_EDIT_REFERENT: "Errore nella modifica del referente.",
      ERROR_IN_FORM_SITE: "Errore nel form del sito.",
      SUCCESS_CREATE_REFERENT: "Referente creato con successo.",
      ERROR_CREATE_REFERENT: "Errore nella creazione del referente.",
      CONFIRM_DELETE_REFERENT: "Sei sicuro di voler eliminare questo referente?",
      SUCCESS_DELETE_REFERENT: "Referente eliminato con successo.",
      ERROR_DELETE_REFERENT: "Errore nell'eliminazione del referente.",
    },
    ERRORS: {
      SELECT_PROVIDER: "Seleziona un fornitore",
    },
    PLACES_PLURAL : "Sedi",
  },
};
